import { useQuery } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { ApiKey } from '../components/enums'

export type GetIncidentsParams = {
  pageNumber?: number
  pageSize?: number
}

export function getIncidents(params: GetIncidentsParams) {
  return axios.get('/threats/user/listing', { params })
}

type UseIncidentsOptions = GetIncidentsParams

export const useIncidents = (options: UseIncidentsOptions = {}) => {
  return useQuery([ApiKey.incidents, ApiKey.list, options], () => getIncidents(options))
}
